import { render, staticRenderFns } from "./ShittyTextInput.vue?vue&type=template&id=0c15df86&"
import script from "./ShittyTextInput.vue?vue&type=script&lang=ts&"
export * from "./ShittyTextInput.vue?vue&type=script&lang=ts&"
import style0 from "./ShittyTextInput.vue?vue&type=style&index=0&id=0c15df86&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports